import { Link, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Modal } from 'web/src/app/root/components/common'
import CustomCheckbox from 'web/src/app/root/components/common/checkbox'

export default function SbuTermsAndConditons({ handleCheckBoxClick }) {
    const [
        isTermsAndConditionsModalOpen,
        setIsTermsAndConditionsModalOpen
    ] = useState(false)

    const { locale } = useSelector(state => state.main)
    const classes = useStyles()

    const handleTermsAndConditionsClick = () => {
        setIsTermsAndConditionsModalOpen(true)
    }

    return (
        <>
            <span>
                <CustomCheckbox
                    onClick={handleCheckBoxClick}
                    className={classes.checkbox}
                />
                {locale.hotSwap.swap_by_user.termsAndConditonsLinkPart}
                <Link
                    onClick={handleTermsAndConditionsClick}
                    className={classes.link}
                >
                    {locale.hotSwap.swap_by_user.termsAndConditonsLink}
                </Link>
            </span>
            <Modal
                hardwareAccelerated
                animationType="slide"
                setOpen={setIsTermsAndConditionsModalOpen}
                open={isTermsAndConditionsModalOpen}
            >
                <h4>
                    {locale.hotSwap.swap_by_user.termsAndConditonsTextHeader}
                </h4>
                <p>
                    {
                        locale.hotSwap.swap_by_user
                            .termsAndConditonsTextFirstParagraph
                    }
                </p>
                <p>
                    {
                        locale.hotSwap.swap_by_user
                            .termsAndConditonsTextSecondParagraph
                    }
                </p>
                <p>
                    {
                        locale.hotSwap.swap_by_user
                            .termsAndConditonsTextThirdParagraph
                    }
                </p>
                <p>
                    {
                        locale.hotSwap.swap_by_user
                            .termsAndConditonsTextFourthParagraph
                    }
                </p>
                <p>
                    {
                        locale.hotSwap.swap_by_user
                            .termsAndConditonsTextFivethParagraph
                    }
                </p>
            </Modal>
        </>
    )
}

const useStyles = makeStyles(() => ({
    link: {
        cursor: 'pointer',
        fontWeight: 800,
        marginLeft: '3px'
    },
    checkbox: {
        margin: 0
    }
}))
